// Grid can be collection view, or artist view
// Collection view grid
// - grid of all images, opening to lightbox, no title / interaction
// 
// Artist view grid 
// - grid of collections, opening to collection
// - title on rollver
// - animate over collection images within grid space 
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getCanGridAnimate
} from '../app/selectors'
import {
  setGridAnimate
} from '../app/actions'
import AppLink from '../app-link'
import MediaAsset from '../media-asset'

class CollectionGridImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0 
    }

    // Between 500ms ~ 2000ms
    this.animateInterval = parseInt(Math.random() * 1500, 10) + 500
  }

  componentDidMount() {
    if (this.props.active) {
      this.startTick()
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      active: nextActive
    } = nextProps
    const {
      active: prevActive
    } = this.props
    if (nextActive !== prevActive) {
      if (!nextActive) {
        this.cancelTick()
      } else {
        this.cancelTick()
        this.startTick()
      }
    }
  }

  componentWillUnmount() {
    this.cancelTick()
  }

  startTick() {
    this.tickTimer = setTimeout(this.tick, this.animateInterval)
  }

  cancelTick() {
    if (this.tickTimer) {
      clearTimeout(this.tickTimer)
      this.tickTimer = null
    }
  }

  tick = () => {
    const { sources } = this.props 

    let index = this.state.index + 1
    index = index >= sources.length - 1 ? 0 : index
    
    this.setState({ index })
    this.tickTimer = setTimeout(this.tick, this.animateInterval)
  }

  handleMouseEnter = () => {
    this.cancelTick()
  }

  handleMouseLeave = () => {
    this.cancelTick()
    this.startTick()
  }

  /*
  tick = () => {
    const { canAnimate, startGridAnimate, stopGridAnimate, sources } = this.props 

    if (this.willAnimate) {
      // Already animating...
      // Move index and call again
      // Unless complete, where we free up canAnimate and
      // stop any further animation 
      if (this.state.index >= (sources.length - 1)) {
        this.setState({
          index: 0
        })
        this.willAnimate = false
        stopGridAnimate()
      } else {
        this.setState({
          index: (this.state.index + 1)
        })
      }
    } else {
      // Random chance of animating 
      const rnd = Math.random() < 0.25
      const willAnimate = canAnimate && rnd

      if (willAnimate) {
        this.willAnimate = true
        startGridAnimate()
      }
    }

    // Call again after 2 seconds  
    this.tickTimer = setTimeout(this.tick, this.willAnimate ? 400 : 2000)
  }
  */

  render() {
    const { index } = this.state
    const { sources } = this.props 
    return (
      <MediaAsset 
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        classNames="collection__grid-image" 
        src={sources && sources[index]} />  
    )
  }
}

const mapStateToProps = state => {
  return {
    canAnimate: getCanGridAnimate(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    startGridAnimate() {
      dispatch(setGridAnimate(true))
    }, 
    stopGridAnimate() {
      dispatch(setGridAnimate(false))
    }
  }
}

const CollectionGridImageContainer = connect(mapStateToProps, mapDispatchToProps)(CollectionGridImage)

const CollectionGridItem = ({ index, sources, title, active, linkHref }) => {

  return (
    <li className="collection__grid-list-item">
      <AppLink to={linkHref}>
        <CollectionGridImageContainer active={active} sources={sources} />
      </AppLink>
      {title && <div className="collection__grid-title text--small-serif" dangerouslySetInnerHTML={{__html: title}} />}
    </li>
  )
}

// Match is route match prop 
// Items are list of image sources 
// (single element array for collection pages, multiple for artist pages)
const CollectionGrid = ({ match, items }) => (
  <div className="collection__grid">
    <ul className="collection__grid-list">
      {items.map(({ id, ...otherProps }) => (
        <CollectionGridItem 
          key={id}
          {...otherProps} />
      ))}
    </ul>
  </div>
)

export default CollectionGrid



// WEBPACK FOOTER //
// ./src/components/collection-grid/index.js